{
  "it": {
    "paginator": {
      "labels": {
        "perPage": "Per Pagina",
        "pages": "%{page} di %{total}"
      }
    }
  }
}
